"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadImage = void 0;
/**
 * @todo replace with bridge-schema methods
 */
function uploadImage() {
    return new Promise(resolve => {
        const onImageSelected = (notification) => __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            window.Utils.EventEmitter.off('WOLControllerDidSelectUserImage', onImageSelected);
            // @ts-ignore
            window.Utils.EventEmitter.off('WOLControllerDidCancelUserImage', onImageSelected);
            const data = notification.userInfo && notification.userInfo.data
                ? notification.userInfo.data
                : notification.object;
            const base64 = notification.userInfo && notification.userInfo.base64
                ? notification.userInfo.base64
                : null;
            if (!data && !base64) {
                resolve('');
                return;
            }
            if (base64) {
                resolve(base64);
                return;
            }
            const image = yield fetch(`/${data}`);
            const blob = yield image.blob();
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
        // @ts-ignore
        window.Utils.EventEmitter.on('WOLControllerDidSelectUserImage', onImageSelected);
        // @ts-ignore
        window.Utils.EventEmitter.on('WOLControllerDidCancelUserImage', onImageSelected);
        // @ts-ignore
        window.Utils.Bridge.callBridgeMethod('requestUserImage:', {
            allowCamera: true,
            allowEditing: true,
            useNativePath: true,
        });
    });
}
exports.uploadImage = uploadImage;
